import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Subscription } from 'rxjs';
import { InsightsRefreshService } from '../model-services/insights-refresh.service';

// Over the whole page while it waits for the insights of its workspace to be worked out again after a change (as when
// the user leaves a model they changed for the analysis), saying why, so the figures it then shows are the new ones
@Component({
    selector: 'app-insights-wait',
    standalone: true,
    imports: [MatProgressSpinnerModule],
    template: `
        @if (waiting) {
        <div class="wait" role="status" aria-live="polite" data-testid="insights-wait">
            <div class="card">
                <mat-spinner diameter="48"></mat-spinner>
                <div>
                    <strong>Updating the insights after your changes</strong>
                    <p>The figures are being worked out again for this workspace. They show here once they're ready, so what you see includes your changes.</p>
                </div>
            </div>
        </div>
        }
    `,
    styles: [`
        .wait { position: fixed; inset: 0; z-index: 1000; display: flex; align-items: center; justify-content: center; padding: 16px; background: rgba(15, 23, 42, .35); }
        .card { display: flex; align-items: center; gap: 18px; max-width: 460px; padding: 20px 24px; border-radius: 12px; background: var(--paper, #fff);
            box-shadow: 0 12px 32px rgba(15, 23, 42, .25); color: var(--ink, #1f2937); }
        .card mat-spinner { flex: none; }
        strong { font-size: 15px; }
        p { margin: 6px 0 0; font-size: 13px; line-height: 1.45; color: var(--slate, #475569); }
    `],
})
export class InsightsWaitComponent implements OnInit, OnDestroy {
    waiting = false;
    private sub?: Subscription;

    constructor(private refreshes: InsightsRefreshService, private changeDetector: ChangeDetectorRef) {}

    ngOnInit() {
        this.sub = this.refreshes.changed.subscribe(() => {
            this.waiting = this.refreshes.waiting;
            this.changeDetector.markForCheck();
        });
    }

    ngOnDestroy() {
        this.sub?.unsubscribe();
    }
}
